import { CreateSession as DLCreateSession, GetGameStatus as DLGetGameStatus, ToggleGameAccess as DLToggleGameAccess } from './../../DL/Games/Games'


const CreateSession = async (ztudentData) => {
    try {
        const response = await DLCreateSession(ztudentData) 

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        
    }
}

const GetGameStatus = async (centerId, gameIdentifier) => {
    try {
        const response = await DLGetGameStatus(centerId, gameIdentifier) 

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        
    }
}

const ToggleGameAccess = async (toggleData) => {
    try {
        const response = await DLToggleGameAccess(toggleData) 

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        
    }
}

export { CreateSession, GetGameStatus, ToggleGameAccess };